// Centralized nav link data — ordered by Ahrefs search volume
// Update this file to change what appears in header mega-menus and mobile nav

export const CUISINE_LINKS = [
  { name: 'Taco trucks', url: '/taco-trucks', emoji: '\u{1F32E}' },
  { name: 'BBQ food trucks', url: '/bbq-food-trucks', emoji: '\u{1F356}' },
  { name: 'Pizza food trucks', url: '/pizza-food-trucks', emoji: '\u{1F355}' },
  { name: 'Dessert food trucks', url: '/dessert-food-trucks', emoji: '\u{1F366}' },
  { name: 'Breakfast food trucks', url: '/breakfast-food-trucks', emoji: '\u{1F95E}' },
  { name: 'Burger food trucks', url: '/burger-food-trucks', emoji: '\u{1F354}' },
  { name: 'Healthy food trucks', url: '/healthy-food-trucks', emoji: '\u{1F957}' },
  { name: 'Asian food trucks', url: '/asian-food-trucks', emoji: '\u{1F961}' },
  { name: 'Gyro food trucks', url: '/gyro-food-trucks', emoji: '\u{1F959}' },
  { name: 'Sandwich food trucks', url: '/sandwich-food-trucks', emoji: '\u{1F96A}' },
];

// Ordered by Ahrefs organic traffic (March 2026)
export const SEATTLE_LOCATIONS = [
  { name: "Saleh's", url: '/schedule/salehs' },                          // 369 traffic
  { name: 'Starbucks Center', url: '/schedule/starbucks-center' },        // 242 traffic
  { name: 'Westlake Park', url: '/schedule/westlake-park' },              // 166 traffic, 44 keywords
  { name: 'Black Raven Brewing', url: '/schedule/black-raven-brewing-company-woodinville' }, // 138 traffic
  { name: 'Broadview Tap House', url: '/schedule/broadview-tap-house' },  // 109 traffic
  { name: "Chuck's Hop Shop", url: '/schedule/chuck-s-hop-shop-greenwood' }, // 34 traffic
];

export const PORTLAND_LOCATIONS = [
  { name: 'Cartopia', url: '/schedule/cartopia-food-cart-pod' },
  { name: 'Pioneer Courthouse Square', url: '/schedule/pioneer-courthouse-square-food-cart-pod' },
  { name: 'Cartlandia', url: '/schedule/cartlandia-food-cart-pod' },
  { name: 'Hawthorne Asylum', url: '/schedule/hawthorne-asylum' },
  { name: 'Portland Mercado', url: '/schedule/portland-mercado' },
  { name: 'Prost Marketplace', url: '/schedule/prost-marketplace' },
];

// Ordered by Ahrefs organic traffic (March 2026)
export const SEATTLE_TRUCKS = [
  { name: 'Birrieria Pepe El Toro', url: '/food-trucks/birrieria-pepe-el-toro' }, // 513 traffic
  { name: 'Lunch On The Plate', url: '/food-trucks/lunch-on-the-plate' },         // 306 traffic
  { name: 'Impeckable Chicken', url: '/food-trucks/impeckable-chicken' },          // 275 traffic
  { name: 'Momo Express', url: '/food-trucks/momo-express' },                     // 173 traffic
  { name: 'Off The Rez', url: '/food-trucks/off-the-rez' },                       // 158 traffic
  { name: 'Gogi On The Go', url: '/food-trucks/gogi-on-the-go' },                 // 139 traffic
];

export const PORTLAND_TRUCKS = [
  { name: "Matt's BBQ", url: '/food-trucks/matt-s-bbq' },
  { name: 'Jojo Food Cart', url: '/food-trucks/jojo-food-cart' },
  { name: 'Pyro Pizza', url: '/food-trucks/pyro-pizza' },
  { name: 'Chicken and Guns', url: '/food-trucks/chicken-and-guns' },
  { name: 'Kim Jong Grillin', url: '/food-trucks/kim-jong-grillin' },
  { name: 'Koi Fusion', url: '/food-trucks/koi-fusion' },
];

// Ordered by Ahrefs keyword search volume (April 2026)
export const AUSTIN_LOCATIONS = [
  { name: 'Meanwhile Brewing', url: '/schedule/meanwhile-brewing' },              // 2,900 vol
  { name: 'Cosmic Coffee + Beer Garden', url: '/schedule/cosmic-coffee-beer-garden' }, // 700 vol
  { name: 'The Picnic', url: '/schedule/the-picnic' },                            // 400 vol
  { name: 'Thicket Food Park', url: '/schedule/thicket-food-park' },              // 20 vol
  { name: 'Arbor Food Park', url: '/schedule/arbor-food-park' },                  // 20 vol
  { name: 'Mueller Trailer Eats', url: '/schedule/mueller-trailer-eats' },        // Mueller neighborhood
];

export const AUSTIN_TRUCKS = [
  { name: 'Nixta Taqueria', url: '/food-trucks/nixta-taqueria' },                 // 4,200 vol
  { name: 'LeRoy and Lewis Barbecue', url: '/food-trucks/leroy-and-lewis-barbecue' }, // 2,100 vol
  { name: "Valentina's Tex Mex BBQ", url: '/food-trucks/valentina-s-tex-mex-bbq' },  // 1,600 vol
  { name: 'Veracruz All Natural', url: '/food-trucks/veracruz-all-natural' },     // 700 vol
  { name: 'Micklethwait Craft Meats', url: '/food-trucks/micklethwait-craft-meats' }, // 600 vol
  { name: 'Cuantos Tacos', url: '/food-trucks/cuantos-tacos' },                   // 500 vol
];

// Ordered by search volume + traffic potential
export const CATERING_EVENT_LINKS = [
  { name: 'Events & festivals', url: '/food-truck-catering/community-events' },
  { name: 'Corporate catering', url: '/food-truck-catering/corporate-catering' },
  { name: 'Wedding catering', url: '/food-truck-catering/wedding-catering' },
  { name: 'Private parties', url: '/food-truck-catering/private-parties' },
  { name: 'Birthday parties', url: '/food-truck-catering/birthday-parties' },
  { name: 'Office lunch', url: '/food-truck-catering/office-lunch' },
  { name: 'Fundraisers', url: '/food-truck-catering/fundraiser' },
  { name: 'Special occasions', url: '/food-truck-catering/special-occasions' },
];

// Ordered by search volume
export const CATERING_CUISINE_LINKS = [
  { name: 'Taco catering', url: '/food-truck-catering/taco-catering', emoji: '\u{1F32E}' },
  { name: 'Pizza catering', url: '/food-truck-catering/pizza-catering', emoji: '\u{1F355}' },
  { name: 'BBQ catering', url: '/food-truck-catering/bbq-catering', emoji: '\u{1F356}' },
  { name: 'Burger catering', url: '/food-truck-catering/burger-catering', emoji: '\u{1F354}' },
  { name: 'Dessert catering', url: '/food-truck-catering/dessert-catering', emoji: '\u{1F366}' },
  { name: 'Asian catering', url: '/food-truck-catering/asian-catering', emoji: '\u{1F961}' },
  { name: 'Breakfast catering', url: '/food-truck-catering/breakfast-catering', emoji: '\u{1F95E}' },
];

export const CATERING_PLANNING_LINKS = [
  { name: 'Food truck rental', url: '/food-truck-rental' },
  { name: 'Hire a food truck', url: '/hire-a-food-truck' },
  { name: 'Catering prices', url: '/food-truck-catering/prices' },
  { name: 'How it works', url: '/catering' },
];
